import React from 'react';

const LinkifiedText = ({ text, className = '' }) => {
  if (!text) return null;

  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9-]+\.[a-zA-Z]{2,}[^\s]*)/g;
  
  // Create an array to store the parts and their types
  const parts = [];
  let lastIndex = 0;
  let match;
  
  // Reset regex lastIndex
  urlRegex.lastIndex = 0;
  
  while ((match = urlRegex.exec(text)) !== null) {
    // Add text before the URL
    if (match.index > lastIndex) {
      parts.push({
        type: 'text',
        content: text.substring(lastIndex, match.index)
      });
    }
    
    // Add the URL
    parts.push({
      type: 'url',
      content: match[0]
    });
    
    lastIndex = match.index + match[0].length;
  }
  
  // Add remaining text
  if (lastIndex < text.length) {
    parts.push({
      type: 'text',
      content: text.substring(lastIndex)
    });
  }

  const handleLinkClick = (e, url) => {
    e.stopPropagation();
    e.preventDefault();
    
    if (!url) return;
    
    let href = url;
    if (!href.startsWith('http://') && !href.startsWith('https://')) {
      href = 'https://' + href;
    }
    
    window.open(href, '_blank', 'noopener,noreferrer');
    return false;
  };

  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (part.type === 'url') {
          let href = part.content;
          if (!href.startsWith('http://') && !href.startsWith('https://')) {
            href = 'https://' + href;
          }
          return (
            <a
              key={index}
              href="#"
              onClick={(e) => handleLinkClick(e, part.content)}
              onMouseDown={(e) => e.stopPropagation()}
              onTouchStart={(e) => e.stopPropagation()}
              className="text-blue-400 underline hover:text-blue-300"
              style={{ 
                cursor: 'pointer', 
                pointerEvents: 'auto',
                position: 'relative',
                zIndex: 999999
              }}
            >
              {part.content}
            </a>
          );
        }
        return <span key={index}>{part.content}</span>;
      })}
    </span>
  );
};

export default LinkifiedText;